import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

import CenteredWrapper from "ui/CenteredWrapper";
import Heading from "ui/Heading";
import { FlexItem, HR } from "components/forms/Forms.styles";
import DiaryForm from "./DiaryForm";
import AccessDenied from "components/AccessDenied";

function DiaryDetailPage() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const { diaryId } = useParams();
  const [diaryData, setDiaryData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateDiary = async (values) => {
    setIsSubmitting(true);
    api
      .patch(`${API_BASE}/api/student-diary/update`, { ...values, diaryId })
      .then((res) => {
        if (res.status == 200 && values?.submitType == 2) {
          // const diaryId = res.data?.data;
          // navigate(`/diary/${diaryId}`);
          navigate("/student-profile/diary");
        }
      })
      .catch(() => alert("Failed to update the diary: " + diaryId))
      .finally(() => setIsSubmitting(false));
  };

  if (!isAuthenticated) {
    return <AccessDenied />;
  }

  useEffect(() => {
    api
      .get(`${API_BASE}/api/student-diary/find?diaryId=${diaryId}`)
      .then((res) => {
        // console.log('============= fetch diary details response: ', res);
        if (res.status == 200) {
          setDiaryData(res.data?.data);
        }
      })
      .catch(() =>
        console.log("failed to fetch diary details data, diaryId: ", diaryId)
      );
  }, [diaryId]);

  return (
    <CenteredWrapper
      display="flex"
      justifyContent="start"
      flexDirection="column"
      mt="80px"
      minHeight="calc(100vh - 180px)"
      maxWidth="900px"
    >
      <FlexItem>
        <Heading variant="h2">Diary Details</Heading>
      </FlexItem>
      <HR className="light" />
      <DiaryForm
        data={diaryData}
        isDisabled={isSubmitting}
        updateDiary={updateDiary}
      />
    </CenteredWrapper>
  );
}

export default DiaryDetailPage;
